import { render, staticRenderFns } from "./Unauthorized.vue?vue&type=template&id=50129f30&scoped=true&"
import script from "./Unauthorized.vue?vue&type=script&lang=ts&"
export * from "./Unauthorized.vue?vue&type=script&lang=ts&"
import style0 from "./Unauthorized.vue?vue&type=style&index=0&id=50129f30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50129f30",
  null
  
)

export default component.exports